var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1658)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A9612C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 2H14.0001C11.791 2 10.0001 3.79086 10.0001 6V24C10.0001 26.2091 11.791 28 14.0001 28H32.0001C34.2093 28 36.0001 26.2091 36.0001 24V6C36.0001 3.79086 34.2093 2 32.0001 2Z",
    fill: "#F17B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6656 18.86C15.6656 18.11 15.7856 17.47 16.0256 16.94C16.2656 16.4 16.6956 15.805 17.3156 15.155C17.9256 14.505 18.3456 13.95 18.5756 13.49C18.8156 13.03 18.9356 12.55 18.9356 12.05C18.9356 11.6 18.8606 11.29 18.7106 11.12C18.5706 10.94 18.3606 10.85 18.0806 10.85C17.5106 10.85 17.2256 11.195 17.2256 11.885V13.01H15.6656V11.99C15.6656 11.14 15.8756 10.49 16.2956 10.04C16.7156 9.58 17.3256 9.35 18.1256 9.35C18.9256 9.35 19.5356 9.58 19.9556 10.04C20.3756 10.49 20.5856 11.14 20.5856 11.99C20.5856 12.63 20.4306 13.255 20.1206 13.865C19.8206 14.475 19.2956 15.175 18.5456 15.965C18.0556 16.485 17.7256 16.91 17.5556 17.24C17.3856 17.56 17.3006 17.905 17.3006 18.275V18.5H20.4356V20H15.6656V18.86ZM21.7014 18.41H23.2914V20H21.7014V18.41ZM26.8386 11.99H25.1136V10.82C25.5836 10.82 25.9586 10.78 26.2386 10.7C26.5286 10.62 26.7586 10.49 26.9286 10.31C27.0986 10.12 27.2486 9.85 27.3786 9.5H28.4886V20H26.8386V11.99Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1658",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1658"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1658",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.3ad9323fafbeffe20b65e2a207c453a2.svg";
export { ForwardRef as ReactComponent };